import { useFormContext } from 'react-hook-form';
import { TextFormFieldProps } from 'modules/experiments/types';
import { StyledVariantFormField } from 'modules/experiments/components/pages/edit/sections/variant_configuration/CommonStyled';
import { InputField } from 'lib/iterable-hook-form';
import { useSchemaValidationErrorTranslations } from 'utils/hooks/useTranslation';
import { ReadOnlyValue } from '../ReadOnlyValue';

export const TextBoxWithErrorContext = ({
  dataTestId,
  isFieldEditable,
  isFieldFocused = false,
  fieldLabel,
  fieldName,
  fieldTemplateErrors,
  fieldValue,
  helperText,
}: TextFormFieldProps) => {
  const {
    formState: { errors },
  } = useFormContext();
  const { zt } = useSchemaValidationErrorTranslations();

  const errorKey = errors[fieldName]?.message?.toString() ?? '';
  const errorText = zt(errorKey) || fieldTemplateErrors;
  const hasError = !!errors[fieldName] || !!fieldTemplateErrors?.length;

  return (
    <StyledVariantFormField
      data-test={dataTestId}
      labelText={fieldLabel}
      hasError={hasError}
      errorText={errorText}
      helpText={isFieldEditable ? helperText : null}
      isHorizontalLayout
    >
      {isFieldEditable ? (
        <InputField name={fieldName} autoFocus={isFieldFocused} />
      ) : (
        <ReadOnlyValue>{fieldValue}</ReadOnlyValue>
      )}
    </StyledVariantFormField>
  );
};
